<!--
  *************************************************************************************************
-->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <!--
    **************************************************************************************
     FILTROS
    **************************************************************************************
  -->
  <div class="container-fluid  p-0">
    <div class="row m-t-xs">
      <div class="col-12">
        <span *ngIf="lastLoad">
          <span class="mx-2" *ngIf="!isLoading()" class="leyenda">
            <i class="fa fa-inbox" aria-hidden="true"></i> {{ lastLoad | date: 'HH:mm' }} h </span>
          <span class="m-xs" *ngIf="isLoading()" class="leyenda">
            <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{ 'PendingTasks.taskloaders' | translate }}
          </span>
        </span>
        <span class="float-right leyenda" *ngIf="isLoaded()">{{ 'Tasks.showing' | translate }}
          {{filteredTasks?.length?filteredTasks?.length:'0'}} de {{totalRecords?totalRecords:'0'}} </span>
      </div>
    </div>
    <div class="row m-t-sm">
      <div class="col-12 p-0">
        <input pInputText class="p-inputtext" type="text" placeholder="{{ 'Tasks.taskFiltersPlaceholder' | translate }}"
          name="filterText" id="filterTextInput" [(ngModel)]="userPrefs.tasksViewPrefs.filters.filterText"
          (ngModelChange)="updateFilter()" aria-controls="DataTables_Table_2" autocomplete="off" tabindex="1" />
      </div>
    </div>
    <div class="row  filterHeader m-t-sm " *ngIf="isActiveFilter()">
      <div class="col-12">
        <!--span> {{ 'DossiersView.filter.active' | translate }}</span-->
        <!-- span> {{ 'Tasks.active.filter' | translate }} </span -->
        <!-- FILTRO TAREAS GESTIONABLES -->
        <!-- <a *ngIf="userPrefs.tasksViewPrefs.filters.filterActiveTasks" class="btn btn-filter btn-xs m-xs"
          (click)="filterByActiveTasks()">
          {{ 'Tasks.managed.tasks' | translate }}
          <i class="fas fa-times" aria-hidden="true"></i>
        </a> -->
        <!-- FILTRO POR FECHA -->
        <a *ngIf="userPrefs.tasksViewPrefs.filters.filterDate" class="btn btn-filter btn-xs m-xs"
          (click)="filterByDate('')">{{ 'DateText.' + userPrefs.tasksViewPrefs.filters.filterDate | translate }} <i
            class="fas fa-times" aria-hidden="true"></i>
        </a>
        <!-- FILTRO POR TIPO DE TAREA -->
        <a *ngIf="userPrefs.tasksViewPrefs.filters.filterTipoTarea" class="btn btn-filter btn-xs m-xs"
          (click)="filterByTipoTarea('')">{{ traduce(userPrefs.tasksViewPrefs.filters.filterTipoTarea) }} <i
            class="fas fa-times" aria-hidden="true"></i>
        </a>
        <!-- FILTRO POR TIPO DE EXPEDIENTE -->
        <a *ngIf="userPrefs.tasksViewPrefs.filters.filterTipoExpediente" class="btn btn-filter btn-xs m-xs"
          (click)="filterByTipoExpediente('')">{{
          traduceTipoExpediente(userPrefs.tasksViewPrefs.filters.filterTipoExpediente) }} <i class="fas fa-times"
            aria-hidden="true"></i>
        </a>
        <!-- FILTRO POR TIPO DE TAREA -->
        <a *ngIf="userPrefs.tasksViewPrefs.filters.filterTipoContrato" class="btn btn-filter btn-xs m-xs"
          (click)="filterByTipoContrato('')">{{ traduceTipoContrato(userPrefs.tasksViewPrefs.filters.filterTipoContrato)
          }} <i class="fas fa-times" aria-hidden="true"></i>
        </a>
        <!-- FILTRO POR BUZON -->
        <a *ngIf="userPrefs.tasksViewPrefs.filters.filterBuzon" class="btn btn-filter btn-xs m-xs"
          (click)="filterByBuzon('')">{{ userPrefs.tasksViewPrefs.filters.filterBuzon.description }} <i
            class="fas fa-times" aria-hidden="true"></i>
        </a>
        <!-- FILTRO TEXTO -->
        <a *ngIf="userPrefs.tasksViewPrefs.filters.filterText" class="btn btn-filter btn-xs m-xs"
          (click)="filterByText('')"> ~ {{ userPrefs.tasksViewPrefs.filters.filterText }} <i class="fas fa-times"
            aria-hidden="true"></i>
        </a>
      </div>
    </div>
    <div class="row " *ngIf="!isLoading()">
      <div class="col-md-9 col-lg-10 col-xl-10 m-t-md">
        <tasksListComponent [(tasksList)]="filteredTasks" [(selectedGroup)]="selectedGroup"
          (rows)="reloadRowCounter($event)" (totalRecords)="reloadTotalCounter($event)"></tasksListComponent>
      </div>
      <div class="col-md-3 col-lg-2 col-xl-2 m-t-md">
        <!-- SELECTOR DE GRUPO -->
        <div class="m-t-md" *ngIf="groups != undefined">
          <h5 class="text-dark"><i class="fa fa-sitemap " aria-hidden="true"></i> Agrupar tareas</h5>
          <p-dropdown [options]="groups" [(ngModel)]="selectedGroup" dataKey="code" (onChange)="changeGroup($event)"
            optionLabel="name"></p-dropdown>
        </div>
        <!-- FILTROS POR EXPEDIENTES -->
        <div class="m-t-md">
          <h5 class="text-dark"><i class="fa fa-archive " aria-hidden="true"></i> {{ 'PendingTasks.byDossier' |
            translate }}</h5>
          <a (click)="openDossierFilter ()" class="btn btn-filter w-100 text-left m-b-sm" pTooltip=""> Expedientes <span
              class="badge badge-filter float-right font-weight-normal">{{dossiersList.length}}</span>
          </a>
        </div>
        <!-- FILTROS POR FECHA -->
        <div class="m-t-md">
          <h5 class="text-dark"><i class="fa fa-calendar-o " aria-hidden="true"></i> {{ 'DateText.byDate' | translate }}
          </h5>
          <a *ngIf="TODAYCOUNT > 0" (click)="filterByDate('TODAY')"
            class="btn btn-filter w-100 d-flex justify-content-between m-b-sm"> {{ 'DateText.TODAY' | translate }} <span
              class="badge badge-filter float-right  font-weight-normal">{{TODAYCOUNT}}</span>
          </a>
          <a *ngIf="YESTERDAYCOUNT > 0" (click)="filterByDate('YESTERDAY')"
            class="btn btn-filter w-100 text-left m-b-sm"> {{ 'DateText.YESTERDAY' | translate }} <span
              class="badge badge-filter float-right font-weight-normal">{{YESTERDAYCOUNT}}</span>
          </a>
          <a *ngIf="
          WEEKCOUNT> 0" (click)="filterByDate('WEEK')" class="btn btn-filter w-100 text-left m-b-sm"> {{
            'DateText.WEEK' | translate }} <span
              class="badge badge-filter float-right font-weight-normal">{{WEEKCOUNT}}</span>
          </a>
          <a *ngIf="
            MONTHCOUNT> 0" (click)="filterByDate('MONTH')" class="btn btn-filter w-100 text-left m-b-sm"> {{
            'DateText.MONTH' | translate }} <span
              class="badge badge-filter float-right  font-weight-normal">{{MONTHCOUNT}}</span>
          </a>
          <a *ngIf="YEARCOUNT > 0" (click)="filterByDate('YEAR')" class="btn btn-filter w-100 text-left m-b-sm"> {{
            'DateText.YEAR' | translate }} <span
              class="badge badge-filter float-right font-weight-normal">{{YEARCOUNT}}</span>
          </a>
          <a *ngIf="
          OLDCOUNT> 0" (click)="filterByDate('OLD')" class="btn btn-filter w-100 text-left m-b-sm"> {{ 'DateText.OLD' |
            translate }} <span class="badge badge-filter float-right font-weight-normal">{{OLDCOUNT}}</span>
          </a>
        </div>
        <!-- GRAFICO TIPO TAREA -->
        <div class="col-12 p-0">
          <h5 class=" text-dark text-uppercase text-center border-bottom pb-2"> {{ 'PendingTasks.taskType' | translate
            }}</h5>
          <div class="col-12 p-0">
            <p-chart [type]="chartTipoTareaType" [data]="_chartTipoTareaData" width="150px" class="p-0 chart-center"
              [options]="uiService.barChartOptions"
              (onDataSelect)="filterByTipoTarea($event?.element?.index)"></p-chart>
            <div class="d-flex justify-content-between m-t-md">
              <ul class="category-list pl-0">
                <li *ngFor="let elemento of chartTipoTareaLabels; let num = index">
                  <a class="p-0" (click)="this.filterByTipoTarea(num)">
                    <i class="fa fa-circle" [style.color]="
                              uiService.backgroundColor[num]
                            " aria-hidden="true">
                    </i>
                    <span class="text-dark">{{ elemento }}</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- GRAFICO TIPO EXPEDIENTE -->
        <div>
          <h5 class=" text-dark text-uppercase text-center border-bottom pb-2"> {{ 'PendingTasks.dossierType' |
            translate }}</h5>
          <div>
            <p-chart [type]="chartTipoExpedienteType" [data]="_chartTipoExpedienteData" width="150px"
              class="p-0 chart-center" [options]="uiService.barChartOptions"
              (onDataSelect)="filterByTipoExpediente($event?.element?.index)"></p-chart>
            <div class="d-flex justify-content-between m-t-md">
              <ul class="category-list pl-0">
                <li *ngFor="let elemento of chartTipoExpedienteLabels; let num = index">
                  <a class="p-0" (click)="this.filterByTipoExpediente(num)">
                    <i class="fa fa-circle" [style.color]="
                              uiService.backgroundColor[num]
                            " aria-hidden="true">
                    </i>
                    <span class="text-dark">{{ elemento }}</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- GRAFICO TIPO CONTRATO -->
        <div>
          <h5 class=" text-dark text-uppercase text-center border-bottom pb-2"> {{ 'PendingTasks.contractType' |
            translate }}</h5>
          <div>
            <p-chart [type]="chartTipoContratoType" [data]="_chartTipoContratoData" width="150px"
              class="p-0 chart-center" [options]="uiService.barChartOptions"
              (onDataSelect)="filterByTipoContrato($event?.element?.index)"></p-chart>
            <div class="d-flex justify-content-between m-t-md">
              <ul class="category-list pl-0">
                <li *ngFor="let elemento of chartTipoContratoLabels; let num = index">
                  <a class="p-0" (click)="this.filterByTipoContrato(num)">
                    <i class="fa fa-circle" [style.color]="
                              uiService.backgroundColor[num]
                            " aria-hidden="true">
                    </i>
                    <span class="text-dark">{{ elemento }}</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- FILTROS POR BUZON -->
        <div class="m-t-md">
          <h5 class="text-dark"><i class="fa fa-envelope-o " aria-hidden="true"></i> {{ 'PendingTasks.byBuzon' |
            translate }}</h5>
          <a (click)="filterByBuzon(buzon)" class="btn btn-filter w-100 text-left m-b-sm"
            *ngFor="let buzon of buzonesList" pTooltip="({{ buzon.identifier }}) {{ buzon.description }}"> {{
            buzon.description }} <span class="badge badge-filter float-right font-weight-normal">{{ buzon.count
              }}</span>
          </a>
          <div class="
                  clearfix">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="showDossierFilter" [responsive]="true" [modal]="true" [resizable]="false" [closable]="true"
  [dismissableMask]="true" [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'60vw'}"
  [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}" header="{{ 'General.exp' | translate }}"
  (onHide)="closeDossierFilter()" styleClass='searchStyle'>
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <input pInputText class="p-inputtext" type="text"
            placeholder="{{ 'Tasks.taskFiltersPlaceholder' | translate }}" name="textDossierFilter"
            id="textDossierFilter" [(ngModel)]="textDossierFilter" (debounceUpKey)="filterDossierByText()"
            appDebounceUpKey autocomplete="off" tabindex="1" />
        </div>
      </div>
      <div class="row" *ngIf="clonedDossierList.length > 0">
        <div class="col-12 scroll-x">
          <table style="width: 100%;">
            <!--thead>
              <tr>
                <th>{{'General.exp' | translate}}</th>
                <th>Cuenta</th>
              </tr>
            </thead-->
            <tbody class="p-table-tbody">
              <tr #rowElem *ngFor="let dossierElement of clonedDossierList"
                (click)="setDossierFilter (dossierElement.dossier)">
                <td class="LONGTEXT">
                  <divisionDetail [project]="dossierElement.dossier.project" [infoLink]="false" [infoTitulo]="true"
                    [parentElement]="rowElem" class="d-inline text-truncate float-left p-0" style="min-width: 50%;">
                  </divisionDetail>
                </td>
                <td>
                  <span class="badge badge-filter float-right font-weight-normal">{{dossierElement.count}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="clonedDossierList.length == 0"> No hay expedientes que cumplan los filtros </div>
    </div>
  </p-scrollPanel>
</p-dialog>